import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import css from './index.module.scss';
import { Icon, Pane } from '@fullstory/components';
import { useHover } from '@fullstory/react-hooks';
import { useIntl } from 'react-intl';

interface DrivableCollapseIcon {
  collapsed: boolean;
  onClick: () => void;
}

export const DrivableCollapseIcon: React.FC<DrivableCollapseIcon> = ({ collapsed, onClick }) => {
  const intl = useIntl();
  const { hovered, hoverProps } = useHover();

  return (
    <Pane
      data-component="DrivableCollapseIcon"
      aria-label={
        collapsed
          ? intl.formatMessage({ defaultMessage: 'Expand icon button', id: '4xRtqL' })
          : intl.formatMessage({ defaultMessage: 'Collapse icon button', id: '/+SIaa' })
      }
      aria-expanded={!collapsed}
      role="button"
      width={16}
      height={16}
      borderRadius={4}
      onClick={onClick}
      className={classNames(css.iconWrapper, { [css.expanded]: !collapsed })}
      {...hoverProps}
    >
      <Icon name="chevron-right" color={hovered ? 'hover' : 'default'} />
    </Pane>
  );
};
